<template lang='pug'>
  div
    app-header
    .u-relative.u-overflow-hide
      .o-wrapper.u-justify-center.u-items-center
        figure.c-main-news__image(style='background-image: url(/static/images/slide_about.jpg)')
        .o-wrapper.u-py6
          h1.c-main-news__title.u-mt0.u-mb0.u-center
            span.u-fw-s-bold Estamos para&nbsp;
            strong.u-fw-bold escucharte
          p.u-white.u-center.u-mx-auto.u-mb0(class='u-10/12@tablet')
            | Si deseas hacernos alguna recomendación o consulta gustosamente lo atenderemos. Ingrese todos los datos indicandos en el siguiente formulario.
    #position-scroll.o-wrapper.u-py5
      .u-flex.u-flex-wrap
        aside.u-flex-1
          ul.u-list-none.u-pl0
            li.u-mb4.u-flex
              i.u-icon.u-mr3.u-fz-h3.u-color-primary.u-mb3 location
              span.u-color-text.u-pt1 {{ company.address }}
            li.u-mb4.u-flex
              i.u-icon.u-mr3.u-fz-h3.u-color-primary.u-mb3 cellphone
              ul.u-color-text.u-pl0
                li.u-mb3
                  span.u-mr2 Prensa:
                  span {{ company.pressPhone }} | {{ company.pressCellphone }}
                li
                  span.u-mr2 Publicidad:
                  span {{ company.publicityPhone }} | {{ company.publicityCellphone }}
            li.u-mb4.u-flex
              i.u-icon.u-mr3.u-fz-h3.u-color-primary.u-mb2 message_border
              span.u-color-text.u-pt1(v-for='email in company.emails') {{ email }}
        form.c-contact__form
          .c-contact__input
            label.has-error(v-if='message.firstName')
              i.u-icon error_face
              span {{ message.firstName }}
            input(@keyup='validate', v-model='formContact.firstName', type='text', name='firstname', placeholder='Nombres')
          .c-contact__input
            label.has-error(v-if='message.lastName')
              i.u-icon error_face
              span {{ message.lastName }}
            input(@keyup='validate', v-model='formContact.lastName', type='text', name='lastname', placeholder='Apellidos')
          .c-contact__input
            label.has-error(v-if='message.email')
              i.u-icon error_face
              span {{ message.email }}
            input(@keyup='validate', v-model='formContact.email', type='email', name='email', placeholder='Correo')
          .c-contact__input
            label.has-error(v-if='message.cellphone')
              i.u-icon error_face
              span {{ message.cellphone }}
            input(@keyup='validate', v-model='formContact.cellphone', type='tel', name='cellphone', placeholder='Número de contacto')
          .c-contact__input
            label.has-error(v-if='message.country')
              i.u-icon error_face
              span {{ message.country }}
            input(@keyup='validate', v-model='formContact.country', type='text', name='country', placeholder='Pais')
          .c-contact__input
            label.has-error(v-if='message.city')
              i.u-icon error_face
              span {{ message.city }}
            input(@keyup='validate', v-model='formContact.city', type='text', name='city', placeholder='Ciudad')
          .c-contact__textarea
            label.has-error(v-if='message.message')
              i.u-icon error_face
              span {{ message.message }}
            textarea(@keyup='validate', v-model='formContact.message', rows='6', placeholder='Mensaje')
          .u-flex.u-flex-wrap.u-width-100.u-justify-between.u-items-start
            vue-recaptcha.u-mb2(sitekey='6LdA-g8UAAAAAEvHOIl8vXLSz9sIsDSe4VgkvMPB')
            button.c-btn.c-btn--primary.u-s-bold.u-fz-h5.u-fw-s-bold(type='button', @click='postForm') ENVIAR MENSAJE
    iframe(
      src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1897.0562071295858!2d-70.24152667895193!3d-18.019985893342778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb8cc6f1113c55425!2sRadio+RCC+Tacna!5e0!3m2!1ses-419!2spe!4v1478712215769', frameborder='0', style='border:0;height:80vh;width:100%', allowfullscreen=''
    )

    app-footer(:show-info='false')
</template>

<script>
  import Validator from 'validatorjs'
  import VueRecaptcha from 'vue-recaptcha'
  import axios from 'axios'
  import { default as swal } from 'sweetalert2'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Contact',
    components: { VueRecaptcha },
    data () {
      return {
        formValidated: false,
        formValidatedFlag: false,
        formContact: {
          cellphone: '',
          city: '',
          country: '',
          email: '',
          firstName: '',
          lastName: '',
          message: '',
          reCaptcha: ''
        },
        rules: {
          cellphone: 'required|phone',
          city: 'required',
          country: 'required',
          email: 'required|email',
          firstName: 'required|name',
          lastName: 'required|name',
          message: 'required'
        },
        message: {
          cellphone: '',
          city: '',
          country: '',
          email: '',
          firstName: '',
          lastName: '',
          message: ''
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      moveDown () {
        window.$('body').animate({scrollTop: window.$('#position-scroll').offset().top}, '1000', 'swing')
      },

      validate () {
        if (this.formValidatedFlag) {
          let validation = new Validator(this.formContact, this.rules)
          validation.passes()
          for (const key in this.formContact) {
            this.message[key] = validation.errors.first(key)
          }
          this.formValidated = validation.passes()
        }
      },

      postForm () {
        this.formValidatedFlag = true
        this.validate()
        this.formContact.reCaptcha = window.$('textarea[name=g-recaptcha-response]').val()

        if (this.formValidated && this.formContact.reCaptcha) {
          let form = this.formContact
          swal({
            title: 'Se esta enviando el mensaje',
            text: 'Espere un momento por favor',
            showConfirmButton: false,
            allowOutsideClick: false
          })
          axios.post(`${window.API_URL}/contact`, form)
            .then((response) => {
              swal({
                title: 'Mensaje Enviado',
                html: 'En breves momentos revisaremos su mensaje <br> Radio RCC',
                allowOutsideClick: false,
                type: 'success',
                timer: 5000,
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#fe7d1c'
              })
              for (const key in this.formContact) {
                this.formContact[key] = ''
              }
            })
            .catch((e) => {
              swal({
                title: 'Error',
                text: 'Vuelva a intentarlo',
                allowOutsideClick: false,
                type: 'error',
                onfirmButtonText: 'Aceptar'
              })
            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Contact/components/ContactScreen.vue